export default __webpack_public_path__ + "static/media/element_45.a211af9e.webp";